import { useTranslation } from 'react-i18next';

import { Button } from '@treezor/design-system';

import { useAppDispatch } from '@/hooks/redux-helpers';
import { useConfirmationDialog } from '@/hooks/useConfirmationModal';

import { removeWebhook } from '@/features/webhooks/store/webhook.actions';
import { openModal } from '@/store/actions/core.actions';

import { IWebhook } from '@/features/webhooks/store/webhook.model';

import { IModifyWebhookModalProps } from './ModifyWebhookModal';

interface IWebhookActionsProps {
  webhook: IWebhook;
}

export const WebhookAction = ({ webhook }: IWebhookActionsProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const RemoveWebhook = useConfirmationDialog({
    title: t('pages.administration.webhooks.action.remove.header'),
    description: `${t('pages.administration.webhooks.action.remove.description')}  ${webhook.url}`,
    confirm: {
      label: t('pages.administration.webhooks.action.remove.remove'),
      color: 'danger',
      action: () => dispatch(removeWebhook(webhook)),
    },
  });

  const toggleModifyWebhookModal = () =>
    dispatch(openModal<IModifyWebhookModalProps>('modifyWebhookModal', { webhook }));

  return (
    <div className="flex gap-3 items-center">
      <Button
        type="button"
        variant="ghost"
        size="s"
        id="support-user-actions-modify-btn"
        disabled={webhook.status !== 'ENABLED'}
        onClick={toggleModifyWebhookModal}
      >
        {t('pages.administration.webhooks.action.update.button').toLocaleUpperCase()}
      </Button>
      <Button
        color="danger"
        size="s"
        variant="ghost"
        id="support-user-actions-delete-btn"
        onClick={RemoveWebhook.toggle}
      >
        {t('pages.administration.webhooks.action.remove.button').toLocaleUpperCase()}
      </Button>
      <RemoveWebhook.ConfirmationDialog />
    </div>
  );
};
